<template>
  <div>
    <b-row>
      <b-col class="mt-3">
        <filter-table
          primary-key="id"
          empty-text="No Documents added."
          :fields="fields"
          :items="documents"
          :slots="templates"
          :show-filter="false"
        >
          <template slot="header" v-if="displayLinks">
            <div class="text-right">
              <dashboard-button />
            </div>
          </template>
          <template slot="hint">
            <div class="upload-area">
              <upload-multiple-files
                :url-upload="`users/${user.id}/docs`"
                @success="onSuccesUpload"
                @upload="uploadStart"
                @cancel="cancelUploadByUser"
                :show-input="true"
                :auto-send="false"
                :params="uploadParams"
              />
            </div>
          </template>
          <template slot="type" slot-scope="record">
            <a href="javascript:" @click.prevent="openModal(record.row.item)">
              {{record.value === 'Salesforce'? 'Documents' : record.value}}
            </a>
          </template>
          <template slot="type" slot-scope="record">
            <a href="javascript:" @click.prevent="openModal(record.row.item)">
              {{ record.value === 'Borrower 1098 Form' ?
              '1098 Mortgage Interest Statement' : record.value }}
            </a>
          </template>
          <template slot="submitted" slot-scope="record">
            {{record.value | date}}
          </template>
          <template slot="download_template" slot-scope="record" class="center-icons">
            <a
              :href="record.row.item.linkTemplate"
              target="_blank"
              v-if="record.row.item.linkTemplate"
            >
              <font-awesome-icon
                icon="download"
                class="text-anchor pointer-cursor"
                v-b-tooltip.hover
                title="Download Template"
              />
            </a>
          </template>
        </filter-table>
      </b-col>
    </b-row>
    <sent-files-modal
      :title="`Sent files - ${modalRecord.type}`"
      ref="sentFilesModal"
      :files="modalRecord.files"
    />
    <verification-user-email
      ref="verificationUserAlert"
      placement="bottomleft"
      :target="targetVerificationUserAlert"
    />
  </div>
</template>

<script>
import { DEFINE_DOCUMENTS } from '@/vuex/modules/documents/types/actions';
import { DEFINE_MISSING_INDICATORS } from '@/vuex/modules/missing/types/actions';

import TitleContainer from '@/components/utils/TitleContainer';
import DocumentsLegend from '@/components/utils/DocumentsLegend';
import ExplicitHint from '@/components/utils/hints/ExplicitHint';
import FilterTable from '@/components/utils/FilterTable';
import UploadMultipleFiles from '@/components/utils/upload/UploadMultipleFiles';
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';
import DashboardButton from '@/components/utils/buttons/navigation/DashboardButton';
import helper from '@/libs/helper';
import BankStatementUpload from './BankStatementUpload';
import FinancialStatementUpload from './FinancialStatementUpload';
import SentFilesModal from './SentFilesModal';

export default {
  components: {
    TitleContainer,
    DashboardButton,
    DocumentsLegend,
    ExplicitHint,
    FilterTable,
    UploadMultipleFiles,
    BankStatementUpload,
    FinancialStatementUpload,
    VerificationUserEmail,
    SentFilesModal,
  },
  name: 'BorrowerDocuments',
  props: {
    documents: {
      type: Array,
      required: true,
    },
    displayLinks: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modalRecord: {},
      uploadParams: { type: 'Guarantor and Borrower Application' },
      showUploadModal: false,
      isMounted: false,
      targetVerificationUserAlert: '',
      modalNoCloseOnBackdrop: false,
      modalNoCloseOnEsc: false,
      modalHideHeaderClose: false,
      fields: [
        { key: 'type', label: 'Type', sortable: true },
        { key: 'submitted', label: 'Submitted', sortable: true },
      ],
      templates: [
        { key: 'submitted' },
        { key: 'download_template' },
        { key: 'type' },
        { key: 'row-details' },
      ],
    };
  },
  created() {
    this.getDocuments();
    this.getMissingIndicators();
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    openModal(record) {
      this.modalRecord = record;
      this.$refs.sentFilesModal.open();
    },
    openUploadModal(record) {
      this.targetVerificationUserAlert = `upload-${record.row.index}`;
      if (this.$refs.verificationUserAlert.isVerified) {
        this.modalRecord = record.row.item;
        this.uploadParams = { type: record.row.item.type };
        if (record.row.item.type === 'Bank Statement') {
          this.openBankStatementModal(record.row.item);
        } else if (record.row.item.type === 'Financial Statement') {
          this.openFinancialStatementModal();
        } else {
          this.modalNoCloseOnBackdrop = false;
          this.modalNoCloseOnEsc = false;
          this.modalHideHeaderClose = false;
          this.showUploadModal = true;
        }
      }
    },
    openBankStatementModal(record) {
      this.$refs.bankStatementModal.open(record.files);
    },
    openFinancialStatementModal() {
      this.$refs.financialStatementModal.open();
    },
    getDocuments() {
      this.$reqs.get(`/users/${this.user.id}/docs`)
        .then((response) => {
          this.$store.dispatch(DEFINE_DOCUMENTS, { docs: response.data });
        })
        .catch(() => {});
    },
    getMissingIndicators() {
      this.$reqs.get(`/users/${this.user.id}/indicators`)
        .then((response) => {
          this.$store.dispatch(DEFINE_MISSING_INDICATORS, { missing: response.data });
        })
        .catch(() => {});
    },
    onSuccesUpload() {
      this.showUploadModal = false;
      this.$swal.fire({
        type: 'success',
        title: 'Uploaded successfully',
      });
      this.getDocuments();
    },
    cancelUploadByUser() {
      this.showUploadModal = false;
    },
    uploadStart() {
      this.modalNoCloseOnBackdrop = true;
      this.modalNoCloseOnEsc = true;
      this.modalHideHeaderClose = true;
    },
    drop() {
      event.stopPropagation();
      event.preventDefault();
    },
    redBadgeTitle(files) {
      return helper.redBadgeTitle(files);
    },
  },
};
</script>
<style scoped>
.upload-area {
  width: 100%;
  margin-left: 18px;
  margin-right: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/documents/BorrowerDocs.vue